<template>
  <v-app>
    <v-main class="bg">
      <v-col style="height: 100vh;padding-top: 80px;" class="pa-0">
        <router-view></router-view>
      </v-col>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      windowHeight: window.innerHeight,
      showHelp: false
    }
  },
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
}
</script>


<style>
@import "./style.css";

/* Assure que le body et l'application prennent toute la place */
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  /* Empêche tout scroll */
}

/* Evite les débordements horizontaux */
.v-application {
  min-height: 100%;
  min-width: 100%;
  overflow: hidden;
  /* Empêche tout scroll dans l'application */
}

/* Optionnel : Styles pour les conteneurs */
.v-main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  /* Supprime tout padding par défaut */
  margin: 0;
  /* Supprime tout margin par défaut */
}
</style>
